import { render, staticRenderFns } from "./uvListModal.vue?vue&type=template&id=3204ca42"
import script from "./uvListModal.vue?vue&type=script&lang=js"
export * from "./uvListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports